import React from "react";
import { render } from "react-dom";
import App from "./App";
import "./styles/global.css";

const appElement = document.getElementById("app");
render(<App />, appElement);
